import Cookies from 'js-cookie';
import * as z4 from 'zod/v4/core';

// See for generic supporting Zod syntax: https://zod.dev/library-authors#how-to-accept-user-defined-schemas
export const readJsonCookie = <T extends z4.$ZodType>(
  schema: T,
  cookieName: string,
) => {
  // We expect this to be a JSON value or absent
  const rawExistingValues = Cookies.get(cookieName);

  if (!rawExistingValues) {
    return null;
  }

  let json;
  try {
    json = JSON.parse(rawExistingValues);
  } catch {
    return null;
  }

  const validationResult = z4.safeParse(schema, json);

  if (!validationResult.success) {
    return null;
  }

  return validationResult.data;
};

export const removeCookie = (cookieName: string) => Cookies.remove(cookieName);
